// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__yk6AI","buttons":"Footer_buttons__15zAE"};